import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, injectIntl } from 'react-intl';
import { compose } from 'redux';

import Accordion from '../Accordion';
import SchoolDataSimple from '../SchoolDataSimple';
import { withRtl } from '../hoc';
import style from './SchoolInfoAccordionD75.scss';
import messages from '../../locale/messages';
import { SchoolAccordion } from '../SchoolAccordion';
import {customisedIntlFormatMessage} from '../../utils/helpers';
import RatingBlocks from '../SchoolInfoRatingBlocks/SchoolInfoRatingBlocks';

const localMessages = defineMessages({
  accordionPerformance: {
    id: 'schoolinfo.accordionPerformance',
    defaultMessage: 'Performance',
    description: 'Accordion label for school performance',
  },
  accordionAcademics: {
    id: 'schoolinfo.accordionAcademics',
    defaultMessage: 'Academics',
    description: 'Accordion label for school Academics',
  },
  accordionActivities: {
    id: 'schoolinfo.accordionActivities',
    defaultMessage: 'Activities',
    description: 'Accordion label for school Activities',
  },
  accordionOtherFeatures: {
    id: 'schoolinfo.accordionOtherFeatures',
    defaultMessage: 'Other Features',
    description: 'Accordion label for school Other Features',
  },
  accordionAccessibility: {
    id: 'schoolinfo.accordionAccessibility',
    defaultMessage: 'Accessibility',
    description: 'Accordion label for school Accessibility',
  },
  accordionOpenHouses: {
    id: 'schoolinfo.accordionOpenHouses',
    defaultMessage: 'Open Houses & Information Sessions',
    description: 'Accordion label for school Open Houses & Information Sessions',
  },
  accordionMoreInfo: {
    id: 'schoolinfo.accordionMoreInfo',
    defaultMessage: 'More Info',
    description: 'More Info',
  },
  schoolDataELLPrograms: {
    id: 'schoolinfo.schoolDataELLPrograms',
    defaultMessage: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
    description: 'ENGLISH LANGUAGE LEARNERS PROGRAMS',
  },
  schoolDataLangaugeCourses: {
    id: 'schoolinfo.schoolDataLangaugeCourses',
    defaultMessage: 'LANGUAGE COURSES',
    description: 'LANGUAGE COURSES',
  },
  virtualLearning: {
    id: 'schoolinfo.virtualLearning',
    defaultMessage: 'VIRTUAL LEARNING',
    description: 'VIRTUAL LEARNING',
  },
  schoolDataAPCourses: {
    id: 'schoolinfo.schoolDataAPCourses',
    defaultMessage: 'ADVANCED PLACEMENT (AP) COURSES',
    description: 'ADVANCED PLACEMENT (AP) COURSES',
  },
  schoolDataAdvancedCourses: {
    id: 'schoolinfo.schoolDataAdvancedCourses',
    defaultMessage: 'ADVANCED COURSES',
    description: 'ADVANCED COURSES',
  },
  schoolDataDiplomaEndorsements: {
    id: 'schoolinfo.schoolDataDiplomaEndorsements',
    defaultMessage: 'DIPLOMA ENDORSEMENTS',
    description: 'DIPLOMA ENDORSEMENTS',
  },
  schoolDataSports: {
    id: 'schoolinfo.schoolDataSports',
    defaultMessage: 'SCHOOL SPORTS',
    description: 'SCHOOL SPORTS',
  },
  schoolDataSportsCoed: {
    id: 'schoolinfo.schoolDataSportsCoed',
    defaultMessage: 'PSAL SPORTS - COED',
    description: 'PSAL SPORTS - COED',
  },
  schoolDataSportsGirls: {
    id: 'schoolinfo.schoolDataSportsGirls',
    defaultMessage: 'PSAL SPORTS - GIRLS',
    description: 'PSAL SPORTS - GIRLS',
  },
  schoolDataSportsBoys: {
    id: 'schoolinfo.schoolDataSportsBoys',
    defaultMessage: 'PSAL SPORTS - BOYS',
    description: 'PSAL SPORTS - BOYS',
  },
  schoolStatsGraduate: {
    id: 'schoolinfo.schoolStatsGraduate',
    defaultMessage: 'of students graduate in four years',
    description: 'percentage of students of graduate. A percent precedes this string (ie 76%) ',
  },
  schoolStatsEnrollCollege: {
    id: 'schoolinfo.schoolStatsEnrollCollege',
    defaultMessage: 'of students enroll in college or career programs',
    description:
      'percentage of students of enroll in college or career programs. A percent precedes this string (ie 76%) ',
  },
  schoolStatsAttendance: {
    id: 'schoolinfo.schoolStatsAttendance',
    defaultMessage: 'student attendance',
    description: 'percentage of student attendance. A percent precedes this string (ie 76%) ',
  },
  schoolStatsSaftey: {
    id: 'schoolinfo.schoolStatsSaftey',
    defaultMessage: 'of students feel safe in the hallways, bathrooms, locker room, and cafeteria',
    description: 'percentage of students who feel safe. A percent precedes this string (ie 76%) ',
  },
  schoolStatsVariety: {
    id: 'schoolinfo.schoolStatsVariety',
    defaultMessage:
      'of students feel that this school offers a wide enough variety of programs, classes, and activities to keep them interested in school',
    description:
      'percentage of student who like the variety the school offers. A percent precedes this string (ie 76%) ',
  },
  secondaryWebsite: {
    id: 'schoolinfo.secondaryWebsite',
    defaultMessage: 'See the School Quality Snapshot',
    description: 'Text for link to school quality snapshot',
  },
  accordionAccessibilityMoreInfo: {
    id: 'schoolinfo.accordionAccessibilityMoreInfo',
    defaultMessage: 'Accessibility More Informatiion',
    description: 'Accordion label for Accessibility More Information',
  },
  accordionCoLocatedSchools: {
    id: 'schoolinfo.accordionCoLocatedSchools',
    defaultMessage: 'Co-located Schools',
    description: 'Accordion label for Co-located schools',
  },
    accordionBAPHelpText: {
    id: 'schoolinfo.accordionBAPHelpText',
    defaultMessage: 'For more details and the most up to date building accessibility information, please view the:',
    description: 'Accordion label for BAP Help Text',
  },
});

class SchoolInfoAccordionD75 extends PureComponent {
  static defaultProps = {
    otherFeatures: [],
  };
  static propTypes = {
    academics: PropTypes.shape({
      ell: PropTypes.arrayOf(PropTypes.shape({})),
      languageClasses: PropTypes.arrayOf(PropTypes.shape({})),
      apCourses: PropTypes.arrayOf(PropTypes.shape({})),
      diplomaEndorsements: PropTypes.arrayOf(PropTypes.shape({})),
      electivesDescription: PropTypes.string.isRequired,
      opportunities: PropTypes.shape([]),
      performance: PropTypes.shape({
        graduation: PropTypes.number,
        enrollCollegeCareer: PropTypes.number,
        saftey: PropTypes.number,
        attendance: PropTypes.number,
        variety: PropTypes.number,
      }).isRequired,
    }).isRequired,
    accessibility: PropTypes.string.isRequired,
    accordionAnalyticsClick: PropTypes.func.isRequired,
    activities: PropTypes.shape({
      activities: PropTypes.arrayOf(PropTypes.shape({})),
      sportsBoys: PropTypes.arrayOf(PropTypes.shape({})),
      sportsCoed: PropTypes.arrayOf(PropTypes.shape({})),
      sportsGirls: PropTypes.arrayOf(PropTypes.shape({})),
      sportsDescription: PropTypes.string,
      activitiesDescription: PropTypes.string,
    }).isRequired,
    openHouses: PropTypes.string.isRequired,
    performance: PropTypes.shape({
      graduation: PropTypes.number,
      enrollCollegeCareer: PropTypes.number,
      attendance: PropTypes.number,
      saftey: PropTypes.number,
      variety: PropTypes.number,
    }).isRequired,
    intl: PropTypes.shape().isRequired,
    otherFeatures: PropTypes.arrayOf(PropTypes.shape({})),
    bapurl: PropTypes.string,
  };

  getAcademicOpportunities = () => {
    const { academics } = this.props;
    const academicsList = academics.opportunities.map(academicItem => (
      <li key={academicItem.name}>{academicItem.name}</li>
    ));
    return <ul className={style.disc}>{academicsList}</ul>;
  };

  getOtherInfo = (listItems, title) => {
    if (!listItems || listItems.length === 0) {
      return null;
    }

    const itemContents = listItems.map(item => item.name).join(', ');

    return <SchoolDataSimple title={title} stat={itemContents} />;
  };

  getTextInformation = (text, title) => {
    if (text) {
      return <SchoolDataSimple title={title} stat={text} />;
    }
    return null;
  };

  getOtherFeatures = () => {
    const { otherFeatures } = this.props;
    const otherFeaturesList = otherFeatures.map(item => <li key={item.name}>{item.name}</li>);
    return <ul className={style.disc}>{otherFeaturesList}</ul>;
  };

  getStatDisplay = (statistic, displayString) => {
    if (!statistic) {
      return null;
    }
    return (
      <li>
        <span className={style.stat}>{statistic}%</span> {displayString}
      </li>
    );
  };

  getBAP = (bapurl) => {
    const { intl } = this.props
    if (bapurl) {
      return (
        <li>
          {customisedIntlFormatMessage(intl, localMessages.accordionBAPHelpText)}{' '}
          <a target="_blank" rel="noopener" href={bapurl}>Building Accessibility Profile</a>
        </li>
      );
    }
    return null
  };
  
  getAccessibilityMoreInfo = () => {
    const { school } = this.props;
    const { accessibility_more_info } = school;
    if (!accessibility_more_info) {
      return null;
    }
    const AccessibilityTypeList = accessibility_more_info.split(',').map(AccessibilityTypeItem => (
      <li key={AccessibilityTypeItem}>{AccessibilityTypeItem}</li>
    ));
    return <ul className={style.disc}>{AccessibilityTypeList}</ul>;
  };

  /* eslint-disable react/no-danger */
  render() {
    const { accordionAnalyticsClick, performance, intl } = this.props;
    const { ell, languageClasses, apCourses, virtualLearning, diplomaEndorsements, electivesDescription } = this.props.academics;
    const { sportsBoys, sportsGirls, sportsCoed, sportsDescription, activitiesDescription } = this.props.activities;
    const { accessibility, openHouses, bapurl } = this.props;

    // Distinct filter labels for middle school
    const acceleratedClassesMessageCode = localMessages.schoolDataAdvancedCourses;
    const sportsCoedMessageCode = localMessages.schoolDataSportsCoed;
    const sportsGirlsMessageCode = localMessages.schoolDataSportsGirls;
    const sportsBoysMessageCode = localMessages.schoolDataSportsBoys;

    return (
      <div className={style.root}>
        <SchoolAccordion
          {...this.props}
          style={style}
        ></SchoolAccordion>
        {( performance.instructionAndPerformanceRating || performance.safetyAndSchoolClimateRating || performance.relationshipsWithFamiliesRating || this.props.secondary_website ) && 
        <Accordion label={intl.formatMessage(messages.generalStringPerformance)} analytics={accordionAnalyticsClick}>
            {performance.instructionAndPerformanceRating && (
              <div className={style.ratingRow}>
                <div className={style.ratingLabel}>
                  {performance.instructionAndPerformanceLabel}
                </div>
                <div className={style.ratingValueLine}>
                  <RatingBlocks
                      score={performance.instructionAndPerformanceRating.score}
                    />
                  <span className={style.ratingText}>
                    {performance.instructionAndPerformanceRating.label}
                  </span>
                </div>
              </div>
            )}
            {performance.safetyAndSchoolClimateRating && (
                <div className={style.ratingRow}>
                  <div className={style.ratingLabel}>
                    {performance.safetyAndSchoolClimateLabel}
                  </div>
                  <div className={style.ratingValueLine}>
                    <RatingBlocks
                        score={performance.safetyAndSchoolClimateRating.score}
                      />
                    <span className={style.ratingText}>
                      {performance.safetyAndSchoolClimateRating.label}
                    </span>
                  </div>
                </div>
              )}
            {performance.relationshipsWithFamiliesRating && (
            <div className={style.ratingRow}>
              <div className={style.ratingLabel}>
                {performance.relationshipsWithFamiliesLabel}
              </div>
              <div className={style.ratingValueLine}>
                <RatingBlocks
                    score={performance.relationshipsWithFamiliesRating.score}
                  />
                <span className={style.ratingText}>
                  {performance.relationshipsWithFamiliesRating.label}
                </span>
              </div>
            </div>
            )}
            {this.props.secondary_website && (
              <div className={style.schoolQualitySnapshotRow}>
                <span dangerouslySetInnerHTML={{
                  __html: performance.school_quality_snapshot_html
                }} />
              </div>
            )}
        </Accordion>}
        {(ell.length > 0 || apCourses.length > 0 || diplomaEndorsements.length > 0 || languageClasses.length > 0 || electivesDescription || virtualLearning) &&
        <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionAcademics)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>
            {this.getAcademicOpportunities()}
            {this.getOtherInfo(ell, customisedIntlFormatMessage(intl, localMessages.schoolDataELLPrograms))}
            {this.getOtherInfo(languageClasses, customisedIntlFormatMessage(intl, localMessages.schoolDataLangaugeCourses))}
            {this.getOtherInfo(apCourses, customisedIntlFormatMessage(intl, acceleratedClassesMessageCode))}
            {this.getTextInformation(electivesDescription, 'Electives')}
            {this.getOtherInfo(diplomaEndorsements, customisedIntlFormatMessage(intl, localMessages.schoolDataDiplomaEndorsements))}
            {this.getTextInformation(virtualLearning, customisedIntlFormatMessage(intl, localMessages.virtualLearning))}
          </div>
        </Accordion>}
        {(activitiesDescription || sportsDescription || sportsCoed.length > 0 || sportsGirls.length > 0 || sportsBoys.length > 0) &&
        <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionActivities)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>
            {this.getTextInformation(activitiesDescription, customisedIntlFormatMessage(intl, localMessages.accordionActivities))}
            {this.getTextInformation(sportsDescription, customisedIntlFormatMessage(intl, localMessages.schoolDataSports))}
            {this.getOtherInfo(sportsCoed, customisedIntlFormatMessage(intl, sportsCoedMessageCode))}
            {this.getOtherInfo(sportsGirls, customisedIntlFormatMessage(intl, sportsGirlsMessageCode))}
            {this.getOtherInfo(sportsBoys, customisedIntlFormatMessage(intl, sportsBoysMessageCode))}
          </div>
        </Accordion>}
        {(accessibility && accessibility.length > 0 || this.getBAP(bapurl) || this.getAccessibilityMoreInfo()) && <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionAccessibility)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>
            <ul>
                <li>{accessibility}</li>
                {this.getBAP(bapurl)}
                {this.getAccessibilityMoreInfo() && (<SchoolDataSimple title={customisedIntlFormatMessage(intl, localMessages.accordionAccessibilityMoreInfo)} stat={this.getAccessibilityMoreInfo()} ></SchoolDataSimple>)}
            </ul>
            </div>
        </Accordion>}
        {openHouses && (
          <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionOpenHouses)} analytics={accordionAnalyticsClick}>
            <div className={style.schoolDataWrapper}>
              <span dangerouslySetInnerHTML={{ __html: openHouses }} />
            </div>
          </Accordion>
        )}
        {(this.props.otherFeatures && this.props.otherFeatures.length > 0) && <Accordion label={customisedIntlFormatMessage(intl, localMessages.accordionOtherFeatures)} analytics={accordionAnalyticsClick}>
          <div className={style.schoolDataWrapper}>{this.getOtherFeatures()}</div>
        </Accordion>}
      </div>
    );
  }
}

export { SchoolInfoAccordionD75 };
export default compose(
  injectIntl,
  withRtl(style),
  withStyles(style),
)(SchoolInfoAccordionD75);
